import {Person} from './person';
import {Debt} from './debt';
import {LifeProject} from './lifeproject/life-project';
import {Desktop} from './desktop';
import {AbstractAsset} from './abstract-asset';
import {WelfareProjectResult} from './result/welfare-project-result';
import {WelfareQuoteProject} from './welfare-quote-project';
import {CollaboratorInfo} from './user/collaborator-info';

export class WelfareProject {
  id: string;
  creationTime: Date;
  lastMod: Date;
  name: string;
  people: Person[] = [];
  debts: Debt[] = [];
  assets: AbstractAsset[] = [];
  lifeProjects: LifeProject[] = [];
  desktop: Desktop = new Desktop();
  single: boolean;
  note: string;
  quote: WelfareQuoteProject;
  welfareProjectResult: WelfareProjectResult;
  theoryFamilyIncome: boolean;
  author: CollaboratorInfo;
  localCopy: boolean;
}
